<template>
  <div></div>
</template>

<script>
import { mapMutations } from 'vuex'
import { ADD_MAP_LAYER, REMOVE_MAP_LAYER } from '@/store/mutation-types'

export default {
  name: 'VectorTileLayer',
  props: {
    before: {
      type: String,
      default: ''
    },
    layerId: {
      type: String,
      required: true
    },
    layer: {
      type: Object,
      required: true
    },
    source: {
      type: Object,
      required: true
    },
    sourceId: {
      type: String,
      required: true
    }
  },
  emits: ['sourceLoaded'],
  watch: {
    layer: {
      deep: true,
      handler() {
        this.updateLayerPaint()
        this.updateLayerLayout()
      }
    }
    /* source: {
      deep: true,
      handler() {
        const { url, coordinates } = this.source
        this.$store.map.getSource(this.sourceId).updateImage({ url, coordinates })
      }
    } */
  },
  mounted() {
    this.addLayerAndSource()
  },
  beforeUnmount() {
    this.removeLayer()
    this.removeSource()
    this.$store.map.off('data', this.onData)
  },
  methods: {
    ...mapMutations({
      addLayerStore: ADD_MAP_LAYER,
      removeLayerStore: REMOVE_MAP_LAYER
    }),
    removeSource() {
      if (!this.$store.map.getSource(this.sourceId)) return
      const layers = this.$store.map.getStyle().layers
      const sourceId = this.sourceId
      const foundIndex = layers.findIndex((el) => el.source === sourceId)
      if (foundIndex === -1) this.$store.map.removeSource(this.sourceId)
    },
    removeLayer() {
      if (this.$store.map.getLayer(this.layerId)) {
        this.$store.map.removeLayer(this.layerId)
        this.removeLayerStore(this.layerId)
      }
    },
    addLayerAndSource() {
      if (!this.$store.map.getSource(this.sourceId))
        this.$store.map.addSource(this.sourceId, this.source)
      if (!this.$store.map.getLayer(this.layerId)) {
        this.$store.map.addLayer(this.layer, this.before)
        this.addLayerStore(this.layerId)
      }
      this.$store.map.on('data', this.onDataChange)
    },
    onDataChange(event) {
      if (event.sourceId === this.sourceId && event.isSourceLoaded) this.$emit('sourceLoaded')
    },
    updateLayerPaint() {
      if (!this.layer.paint) return
      for (const property in this.layer.paint) {
        this.$store.map.setPaintProperty(this.layerId, property, this.layer.paint[property])
      }
    },
    updateLayerLayout() {
      if (!this.layer.layout) return
      for (const property in this.layer.layout) {
        this.$store.map.setLayoutProperty(this.layerId, property, this.layer.layout[property])
      }
    }
  }
}
</script>
